import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";
import BaseModal from "@/components-UI/modals/BaseModal.vue";
import BaseInputNumber from "@/components-UI/BaseInputNumber.vue";
import BaseTextarea from "@/components-UI/BaseTextarea.vue";
import { IAffiliateInvoice, IRespCreatePartialPayment } from "@/api/types/payout";
import store from "@/store";
import BaseListItem from "@/components-UI/list/BaseListItem.vue";
import BaseList from "@/components-UI/list/BaseList.vue";
import { showServerError } from "@/utils";
import { NotificationMessage } from "@/utils/notification";
import { addPartialPaymentMyLeadgidInvoice } from "@/api/payout";
import { storeToRefs } from "pinia";
import { useAffiliateInvoiceStore } from "@/store_v3/AffiliateInvoiceStore";

interface Props {
    invoice: IAffiliateInvoice;
}

export default /*#__PURE__*/_defineComponent({
  __name: 'AddPaymentForm',
  props: {
    invoice: null
  },
  setup(__props: any, { expose }) {

const props = __props as {
    invoice: IAffiliateInvoice;
}


const { isNeedUpdateInvoice } = storeToRefs(useAffiliateInvoiceStore());

const isShow = ref(false);
const amount = ref(0);
const description = ref("");
const isLoading = ref(false);

const getCurrencySymbol = computed(() => {
    return store.getters['catalogueModule/GET_CURRENT_CURRENCY_ICON'](props.invoice.currency);
});

const openModal = () => {
    isShow.value = true;
    amount.value = getRestSum.value;
};

const hideModal = () => {
    isShow.value = false;
    amount.value = 0;
    description.value = "";
};

const getPaidSum = computed(() => {
    if (props.invoice.paid_status === 'paid') {
        return props.invoice.total_amount;
    }
    const part = props.invoice.partials;
    if (Array.isArray(part) && part.length) {
        return part.reduce((a, i) => a + i.amount, 0);
    }
    return 0;
});

const getRestSum = computed(() => props.invoice.total_amount - getPaidSum.value);

const addPayment = async () => {
    try {
        isLoading.value = true;
        const data = {
            amount: amount.value,
            description: description.value,
        };
        const response = await addPartialPaymentMyLeadgidInvoice(props.invoice.id, data) as IRespCreatePartialPayment;
        new NotificationMessage(`Добавлен платёж суммой в ${amount.value} ${response.currency}`, 'success' );
        hideModal();
        isNeedUpdateInvoice.value = true;
    } catch (err) {
        showServerError(err, 'Платёж не добавлен');
    } finally {
        isLoading.value = false;
    }
};

expose({
    openModal,
});

return { __sfc: true,props, isNeedUpdateInvoice, isShow, amount, description, isLoading, getCurrencySymbol, openModal, hideModal, getPaidSum, getRestSum, addPayment, BaseModal, BaseInputNumber, BaseTextarea, BaseListItem, BaseList }
}

})